<template lang="pug">
  v-container(fluid)
    //- h2.text-center {{ translations.title }}
    h2.text-center Refer A Friend
    v-row.px-2.px-sm-10.pb-10
      v-col(cols="12" sm="6" md="4")
        BaseChipSelectField(:multiple="false", :items="operatorsListAll" v-model="operator", label="Operador")
    v-row.px-2.px-sm-10.pb-10
      v-col(cols="12")
        v-data-table(
          :headers="headers"
          :items="datos"
          :items-per-page="30"
          :footer-props="{'items-per-page-options': [10, 20, 30, 40, 50], 'itemsPerPageText': $t('api.datatable.rowsperpage')}"
        )
          template(v-slot:item="{ item }")
            tr
              td
                span {{ item.username }}
              td
                span {{ item.referral }}
              td
                span {{ item.totalstake }}
              td
                span {{ item.return }}
              td
                span {{ item.ngr }}
              td
                BaseDetailDialog(button="Ver detalles", :title="'Usuario: ' + item.username")
                  BaseDefinitionList(:items="getDetails(item)" keysAlign="text-left text-sm-right")
      v-col(cols="12")
        v-alert( color="blue-grey" dark) pendiente hacer la llamada con usando el id del operador
              //- td
              //-   BaseConfirmDialog(v-bind="translations.confirmationDialog.status" @confirm="toggleState(item.id)")
              //-     template(v-slot="{ on }")
              //-       v-btn(v-on="on", :color="getColor(item.status.value)", :loading="loadingToggleReferAFriend" dark rounded) {{ item.status.text }}

</template>

<script>

  export default {
    name: "ReferAFriendIndex",
    // components: {
    //   FreeroundsEditDialog,
    // },
    data: () => ({
      operator: null,
    }),
    computed:{
      translations() {
        return this.$t("views.freeroundsIndex");
      },
      translationsForm() {
        return this.$t("forms.freerounds");
      },
      headers() {
        let headers = [
          {
            text: 'Nombre de usuario',
            value: 'username'
          },
          {
            text: 'Número de usuarios referidos',
            value: 'referral'
          },
          {
            text: 'Total Stake',
            value: 'totalstake'
          },
          {
            text: 'Return',
            value: 'return'
          },
          {
            text: 'NGR',
            value: 'ngr'
          },
          {
            text: '',
            value: 'details',
            sortable: false
          },
        ];
        return headers;
      },
      datos(){
        // const vm = this;
        // return this.competitionListAll.map(competition =>{
        //   return {
        //     _id: competition._id,
        return [
          {
            _id: '123',
            username: 'test 11',
            referral: 35,
            totalstake: 12,
            return: 'sí',
            ngr: true,
            firstBet: 200,
            dateBet: '11/09/2020',
          },
          {
            _id: '456',
            username: 'test 21',
            referral: 64,
            totalstake: 25,
            return: 'sí',
            ngr: false,
            firstBet: 100,
            dateBet: '08/10/2020',
          }]
      },
      // loadingToggleReferAFriend(){
      //   return this.$store.state.statusCode.toggleReferAFriend.loading;
      // },
      // statusToggleState(){
      //   return this.$store.state.statusCode.toggleReferAFriend.state || '';
      // },
      operatorsListAll() {
        return this.$store.state.operators.map(operator => ({
          text:operator.n,
          value:operator._id
        })).sort((a, b) => a.text.localeCompare(b.text));
      },
      referAFriendListAll() {
        return this.$store.state.referafriend;
      },
    },
    // watch: {
    //   statusToggleState: function (val) {
    //     if (val == 200) {
    //       this.$store.dispatch('getReferAFriend');
    //     }
    //   },
    // },
    created(){
      this.$store.dispatch('getOperators');
      this.$store.dispatch('getReferAFriend');
    },
    methods: {
      getColor(type){
        return type ? 'green': 'red';
      },
      // toggleState(referAFriendId){
      //   this.$store.dispatch('toggleReferAFriend', referAFriendId);
      // },
      getDetails(item){
        return [
          {
            // key: this.translations.dialog.details.labels.name,
            key: 'Nombre de usuario',
            value: item.username
          },
          {
            key: 'Total Stake',
            value: item.totalstake
          },
          {
            key: 'Return',
            value: item.return
          },
          {
            key: 'NGR',
            value: item.ngr
          },
          {
            key: 'Primera apuesta',
            value: item.firstBet
          },
          {
            key: 'Fecha apuesta',
            value: item.dateBet
          },
        ];
      },
    },
  }
</script>

<style lang="sass">
</style>